<template>
  <li :class="{ selected: selected }">
    <div class="top-row">
      <select-box
        class="select-holder"
        @action="$emit('select-box')"
        :selected="selected"
        :color="rootStore.interaction.subColor"
      ></select-box>
      <p class="file-name user-text" :title="file.fileName">
        {{ file.fileName }}
      </p>
      <remove-button
        class="remove-file"
        @remove="removeFile(file.uuid)"
      ></remove-button>
    </div>
    <div class="specs-row">
      <quantity-input
        v-model="file.quantity"
        @update:val="$emit('set-qt', $event)"
        @click.native.stop="$emit('input-select')"
      ></quantity-input>
      <div class="specs-holder">
        <span class="select-text" v-show="!file.productSpecs.title">
          Selecteer een product
        </span>

        <div v-show="file.productSpecs" class="product-specs">
          <div class="product-title">
            <span>{{ file.productSpecs.title }}</span>
          </div>
          <div class="specs">
            <span v-for="(value, name) in productSpecs" :key="name"
              >{{ name }}: {{ value }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import QuantityInput from '@/components/ui/QuantityInput'
import RemoveButton from '@/components/ui/RemoveButton'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'

export default {
  props: {
    selected: Boolean,
    file: Object
  },
  components: {
    QuantityInput,
    RemoveButton
  },
  methods: {
    removeFile(val) {
      fileListStore.removeFile(val)
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    productSpecs() {
      const myObj = { ...this.file.productSpecs }
      delete myObj.title
      return myObj
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../../sass/base/colors.scss' as *;

li {
  padding: 15px;
  margin-bottom: 5px;
}

.selected {
  background-color: $list-selected;
  border-radius: 15px;
}

.top-row {
  display: flex;
  flex-direction: row;
}

.specs-row {
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}
.specs-holder {
  display: flex;
  align-items: center;
}

.remove-file {
  margin-left: auto;
}

.input-holder {
  margin-right: 10px;
  margin-top: 0;
}

.select-text {
  padding-top: 14px;
}

.specs {
  span {
    display: inline-block;
    margin: 5px 8px 5px 5px;
  }
}

.product-title {
  padding: 1px 5px 5px;
  font-weight: 600;
}
</style>
